<script setup lang="ts">
/**
 * InitiativeBadge — badge discreto indicando nível R1-R6 ativo.
 * Sem cores brilhantes, sem animação pulsante (CC-06).
 *
 * HLOS-114: imports atualizados. `Initiative` agora vem de `../ui-constraints`
 * (TS-only, alinhado com codegen 7-kind enum). `RLevel` vem de `../generated`
 * (canônico, gerado de Python source via HLOS-113 codegen).
 */
import type { Initiative } from "../ui-constraints";
import type { RLevel } from "../generated";

interface Props {
  initiative: Initiative;
}

const props = defineProps<Props>();

const rLevelLabel = (r: RLevel): string => r;
</script>

<template>
  <aside
    v-if="props.initiative.kind !== 'none' && props.initiative.text"
    class="hlos-initiative"
    :data-r-level="props.initiative.rLevel"
    :data-kind="props.initiative.kind"
    data-testid="initiative-badge"
    role="note"
  >
    <small>
      <strong>{{ rLevelLabel(props.initiative.rLevel) }}</strong>
      {{ props.initiative.text }}
    </small>
  </aside>
</template>

<style scoped>
.hlos-initiative {
  padding: 0.5rem 0.75rem;
  margin: 0.5rem 0;
  background: color-mix(in srgb, currentColor 5%, transparent);
  border-left: 3px solid color-mix(in srgb, currentColor 30%, transparent);
  border-radius: 0.25rem;
  font-size: 0.9em;
  opacity: 0.9;
}
small {
  display: block;
  line-height: 1.4;
}
strong {
  margin-right: 0.5rem;
  font-family: ui-monospace, monospace;
  font-weight: 600;
}
</style>
